import { supabase } from './supabase';

export interface MaterialData {
  materialId: string;
  description: string;
  descriptionDE: string;
  unit: string;
  length: number;
  width: number;
  price: number;
  weight: number;
  category: string;
  finish: string;
  load: number;
  maxShelves: number;
  glbFile: string;
}

interface DbMaterial {
  material_id: string;
  description: string;
  description_de: string;
  unit: string;
  length: number;
  width: number;
  price: number;
  weight: number;
  category: string;
  finish: string;
  load: number;
  max_shelves: number;
  glb_file: string;
}

function mapDbMaterial(row: DbMaterial): MaterialData {
  return {
    materialId: row.material_id,
    description: row.description,
    descriptionDE: row.description_de,
    unit: row.unit,
    length: row.length,
    width: row.width,
    price: Number(row.price),
    weight: Number(row.weight),
    category: row.category,
    finish: row.finish,
    load: row.load,
    maxShelves: row.max_shelves,
    glbFile: row.glb_file,
  };
}

export async function fetchMaterials(): Promise<MaterialData[]> {
  const { data, error } = await supabase.rpc('get_materials_for_role');

  if (error) {
    throw new Error(`Failed to fetch materials: ${error.message}`);
  }

  return (data as DbMaterial[]).map(mapDbMaterial);
}
